import { useContext, useEffect } from "react";
import { CompanySchemaType } from "@/pages/requests/components/contract-details-form/types";
import { logger, normalizeDropdownOptionsData } from "@/utils";
import { AuthContext } from "@/guards/auth/auth-context";
import { useRequestState } from "@/hooks";
import { requestCompaniesList } from "@/services/api";

export const useCompanies = () => {
  const { account } = useContext(AuthContext);

  const {
    data: companies,
    error,
    setError,
    isLoading,
    setSuccess,
  } = useRequestState<CompanySchemaType[]>();

  useEffect(() => {
    const controller = new AbortController();

    requestCompaniesList(
      { email: account?.username ?? "" },
      { signal: controller.signal },
    )
      .then(async response => {
        setSuccess(normalizeDropdownOptionsData(response, "CompanyNameEn"));
      })
      .catch(error => {
        setError(error.message);

        logger.error(error);
      });

    return () => {
      controller.abort();
    };
  }, [account, setError, setSuccess]);

  return { isLoading, companies: companies || [], error };
};
